import { render, staticRenderFns } from "./index1-4(3).vue?vue&type=template&id=3cfebe63&scoped=true&"
import script from "./index1-4(3).vue?vue&type=script&lang=js&"
export * from "./index1-4(3).vue?vue&type=script&lang=js&"
import style0 from "./index1-4(3).vue?vue&type=style&index=0&id=3cfebe63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfebe63",
  null
  
)

export default component.exports